import React, { useEffect, useState } from "react";
import { IonButton, IonNote } from "@ionic/react";
import { useTranslation } from "react-i18next";
import PersonalQR from "../components/PersonalQrCode";
import FlavoriaPage from "../components/FlavoriaPage";
import MealLogged from "../components/MealLogged";
import useNewMeals from "../utils/useNewMeals";
import BackendFactory from "../API/BackendFactory";
import { UserInfoObject } from "../API/lib/JsonUtils";

const QR: React.FC = () => {
  const { t } = useTranslation();
  const newMeals = useNewMeals();
  const [receipthero, setReceipthero] = useState<boolean | null>(null);

  useEffect(() => {
    const BE = BackendFactory.getBackend();
    BE.getUserInfo()
      .then((result) => {
        const uo = new UserInfoObject(result);
        setReceipthero(uo.getUserInfo().receipthero ?? false);
      })
      .catch(() => { /* ignored */ });
  }, []);

  return (
    <FlavoriaPage pageID={"ACTIVE_PAGE_QR"}>
      <br />
      <PersonalQR maxSize={512} />
      <center>
        <br />
        <IonNote>
          {t("Please show this QR-code to the reader next to the cash register.")}
        </IonNote>
      </center>

      {receipthero !== null && (
        <div style={{ textAlign: "center", margin: "16px 0" }}>
          <a
            href="https://www.flavoria.fi/receipthero"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-flex",
              alignItems: "center",
              fontSize: "14px",
              fontWeight: 600,
              textDecoration: "none",
              cursor: "pointer",
              borderRadius: "20px",
              overflow: "hidden",
              border: "1px solid",
              borderColor: receipthero ? "#2e7d32" : "#ccc",
            }}
          >
            <span
              style={{
                padding: "8px 12px",
                color: "#fff",
                backgroundColor: "#37474f",
              }}
            >
              ReceiptHero
            </span>
            <span
              style={{
                padding: "8px 12px",
                color: receipthero ? "#fff" : "#555",
                backgroundColor: receipthero ? "#2e7d32" : "#e0e0e0",
              }}
            >
              {t(receipthero ? "ReceiptHero linked" : "ReceiptHero unlinked")}
            </span>
          </a>
        </div>
      )}

      <MealLogged
        mealId={newMeals ? newMeals : ""}
        showMealExtraPopup={newMeals != null}
      />

      {/android|iphone|ipad/i.test(navigator.userAgent) && (
        <center>
          <IonButton
            fill="solid"
            href={
              /android/i.test(navigator.userAgent)
                ? "https://l14k.tuudo.fi/b004"
                : "https://apps.apple.com/fi/app/tuudo/id1128326282"
            }
          >
            Tuudo 🔗
          </IonButton>
        </center>
      )}
    </FlavoriaPage>
  );
};

export default QR;
